import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatAxiosError } from "@/lib/api";
import { ArrowLeft, ArrowRight, Envelope } from "@phosphor-icons/react";
import { useBranding } from "@/context/BrandingContext";

export default function ForgotPassword() {
  const branding = useBranding();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (er) { setErr(formatAxiosError(er)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white">
      <div className="max-w-md w-full">
        <Link to="/login" className="flex items-center gap-1 text-xs text-muted-foreground mb-6 hover:text-foreground" data-testid="back-to-login">
          <ArrowLeft size={12} weight="bold" /> Back to sign in
        </Link>
        <div className="eyebrow mb-3">Reset access</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight leading-tight">Forgot your password?</h1>
        <p className="text-sm text-muted-foreground mt-3">
          Enter your work email and we'll send you a link to reset your password. The link is valid for 60 minutes.
        </p>
        {sent ? (
          <div className="mt-8 border border-green-500 bg-green-50 text-green-800 p-4 text-sm" data-testid="forgot-sent">
            <div className="font-semibold mb-1">Check your inbox</div>
            If an account exists for <b>{email}</b>, you'll receive a reset link shortly.
            If your workspace hasn't configured email delivery, your administrator can share the reset link with you.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="eyebrow block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-border bg-white px-4 py-3 text-sm"
                placeholder="name@company.com"
                data-testid="forgot-email"
              />
            </div>
            {err && <div className="border border-[#FF3B30] bg-[#FFF5F5] text-[#FF3B30] px-4 py-2 text-sm">{err}</div>}
            <button
              type="submit"
              disabled={busy}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 text-white text-sm font-semibold uppercase tracking-wide hover:opacity-90 transition disabled:opacity-50"
              style={{ backgroundColor: branding?.brand_mark_color || "#002FA7" }}
              data-testid="forgot-submit"
            >
              {busy ? "Sending…" : "Send reset link"} <ArrowRight size={16} weight="bold" />
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
